import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { SubscriptionService } from "../../services/subscription.service";
import { ISubscription } from "../../models/Subscription";

export const useGetAllSubscriptionsQuery = () => {
  return useQuery<ISubscription[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_SUBSCRIPTIONS],
    queryFn: () => SubscriptionService.getAllSubscriptions().then((res) => res.data),
  });
};
